import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Typography, Box, Card } from "@mui/material";

const Chart = ({ aspect, title, predictionData }) => {
  if (!predictionData) {
    return (
      <Card sx={{ p: 3, boxShadow: 3, borderRadius: 4, mb: 4 }}>
        <Typography>Loading...</Typography>
      </Card>
    );
  }

  const firstSevenItems = predictionData.slice(0, 7).reverse();

  return (
    <Card
      sx={{
        flex: 4,
        p: 3,
        boxShadow: 3,
        borderRadius: 4,
        color: "text.secondary",
        mb: 4,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 3,
          fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
          fontWeight: 600,
          color: 'text.primary',
        }}
      >
        {title}
      </Typography>

        <Box sx={{ 
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
          <ResponsiveContainer width="100%" aspect={aspect}>
            <BarChart
              data={firstSevenItems}
              margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
              barSize={50}
            >
              <defs>
                <linearGradient id="colorCount" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#3498db" stopOpacity={0.9}/>
                  <stop offset="95%" stopColor="#2c3e50" stopOpacity={0.8}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#e4e1e1" />
              <XAxis 
                dataKey="date" 
                stroke="#666"
                style={{ fontSize: '0.875rem' }}
              />
              <YAxis 
                dataKey="count" 
                stroke="#666"
                style={{ fontSize: '0.875rem' }}
              />
              <Tooltip 
                contentStyle={{
                  backgroundColor: 'white',
                  border: '1px solid #e0e0e0',
                  borderRadius: 8,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
              />
              <Bar 
                dataKey="count" 
                fill="url(#colorCount)"
                radius={[8, 8, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </Box>

    </Card>
  );
};

export default Chart;
